import Layout from "../components/Layout";
import { kebijakanPrivasiMeta, defaultURL } from "../data/DataMetatags";
import NextHead from "../components/Seo/NextHead";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { kebijakanPrivasiBreadcrumb } from "../data/DataBreadcrumb";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import HeadingComponent from "../components/UserInterface/HeadingComponent";
import Description from "../components/UserInterface/Description";
import { DataKebijakanPrivasi } from "../data/DataKebijakanPrivasi";
import { yearConst } from "../utils/constanta";

const kebijakanPrivasi = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={kebijakanPrivasiBreadcrumb} />
      <LayoutCenter column>
        <HeadingComponent headingText="Kebijakan Privasi & Persetujuan Pengguna atas Data dan/atau Informasi Pribadi "></HeadingComponent>
        <Description
          align="left"
          font="Roboto"
          text={DataKebijakanPrivasi.text}
        ></Description>
        <ol>
          <li style={{ listStyleType: "decimal", marginLeft: "40px" }}>
            Home Credit dapat memperoleh dan mengumpulkan, dan saya secara
            sukarela telah menyerahkan informasi pribadi saya kepada Home Credit
            untuk keperluan permohonan dan terkait fasilitas pembiayaan yang
            saya terima, agar Home Credit dapat berkomunikasi dengan saya dan
            memberikan layanan terbaiknya selama pembiayaan berlangsung, serta
            mengolah dan menganalisis informasi pribadi saya untuk tujuan-tujuan
            sebagaimana diuraikan di bawah ini. Dalam memperoleh dan
            mengumpulkan informasi pribadi saya, Home Credit dapat memperolehnya
            dari saya sendiri dan dari Pihak Ketiga (sebagaimana diartikan dalam
            butir 2.(iii) di bawah ini);
          </li>
          <li style={{ listStyleType: "decimal", marginLeft: "40px" }}>
            <strong>
              Penggunaan informasi pribadi untuk Pembiayaan, Peningkatan
              layanan, Survey, Penelitian/Analises, Kerja Sama dan/atau Promosi
              dengan Pihak Ketiga
            </strong>
          </li>
        </ol>
      </LayoutCenter>
      <Description
        margin="16px"
        align="left"
        font="Roboto"
        width="940px"
        text={`Saya telah memberikan wewenang dan kuasa penuh kepada Home Credit atau
        perwakilannya yang sah:`}
      ></Description>
      <LayoutCenter margin="0 16px" column>
        <ol>
          <li style={{ listStyleType: "lower-roman", marginLeft: "40px" }}>
            Untuk mengolah dan menganalisis informasi pribadi saya untuk tujuan
            pemeriksaan dan verifikasi informasi pribadi saya, catatan-catatan
            biro kredit, referensi-referensi sehubungan dengan diri pribadi
            saya, untuk menilai dan memproses profil saya sehubungan dengan
            pembiayaan saya, dan untuk melakukan verifikasi dan analisis
            informasi pribadi saya dengan data dan informasi yang tersedia sah
            secara hukum sehubungan dengan layanan telekomunikasi dan telepon
            seluler saya, surat keterangan pajak saya, dan/atau data jaminan
            sosial saya;
          </li>
          <li style={{ listStyleType: "lower-roman", marginLeft: "40px" }}>
            Untuk mengungkapkan dan mengirimkan informasi pribadi saya kepada
            Pihak Ketiga untuk keperluan pengolahan, mendapatkan data hasil
            olahan dan analisis sebagaimana diuraikan dalam butir 2. di atas,
            untuk meningkatkan layanan komunikasi Home Credit dengan saya, untuk
            keperluan survey konsumen, untuk keperluan penelitian dan analisis
            pasar, untuk keperluan kerja sama dengan Pihak Ketiga sehubungan
            dengan produk tambahan, program <i>bundling</i> dan/atau promosi
            yang dipilih oleh saya, dan secara umum untuk meningkatkan layanan
            Home Credit kepada saya selaku konsumen dan yang diperbolehkan
            menurut peraturan perundang-undangan yang berlaku;
          </li>
          <li style={{ listStyleType: "lower-roman", marginLeft: "40px" }}>
            Pihak Ketiga adalah setiap biro informasi kredit yang tersedia,
            pusat data identitas dari pihak ketiga mana pun yang tersedia sah
            secara hukum, lembaga keuangan mana pun, setiap otoritas pemerintah
            yang berwenang, setiap anggota grup Home Credit dan/atau setiap
            pihak ketiga lainnya, termasuk namun tidak terbatas pada perusahaan
            penyedia layanan telekomunikasi di Indonesia, mitra perusahaan
            asuransi, mitra perusahaan perbankan, mitra penyedia jasa, yang
            terikat secara resmi dan sah dengan Home Credit; dan
          </li>
          <li style={{ listStyleType: "lower-roman", marginLeft: "40px" }}>
            Untuk menyimpan informasi pribadi saya berikut data hasil olahan dan
            analisisnya, baik secara langsung oleh Home Credit dan.atau oleh
            Pihak Ketiga, selama jangka waktu pembiayaan berlangsung dan setelah
            selesainya sebagaimana diatur dalam peraturan perundang-undangan
            yang berlaku untuk penawaran pembiayaan di kemudian hari oleh Home
            Credit.
          </li>
        </ol>
      </LayoutCenter>
      <Description
        margin="16px"
        align="left"
        font="Roboto"
        width="940px"
        text={`Apabila aplikasi untuk fasilitas pembiayaan saya termasuk, akan tetapi
        tidak terbatas pada, fasilitas pembiayaan, disetujui oleh Home
        Credit, saya menyadari sepenuhnya bahwa pembiayaan tersebut
        menjadi tanggung jawab penuh saya dan seluruh riwayat pembayaran saya
        berdasarkan perjanjian Pembiayaan akan dilaporkan ke Otoritas
        Jasa Keuangan (“<strong>OJK</strong>”) dan/atau otoritas pemerintah
        terkait sesuai dengan peraturan perundang-undangan yang berlaku.`}
      ></Description>
      <Description
        margin="16px"
        align="left"
        font="Roboto"
        width="940px"
        text={`<strong>© Hak Cipta ${yearConst} PT Home Credit Indonesia</strong>`}
      ></Description>
      <style jsx>
        {`
          @media only screen and (max-width: 600px) {
            li,
            strong {
              font-size: 12px;
            }
          }
        `}
      </style>
    </Layout>
  );
};

kebijakanPrivasi.getInitialProps = ({ asPath }) => {
  const pageTitle = kebijakanPrivasiMeta.title;
  const descriptionSEO = kebijakanPrivasiMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};

export default kebijakanPrivasi;
